import { isBefore, sub } from 'date-fns';

export const dayRegex = /\b(0?[1-9]|[1-2][0-9]|[3][0-1])\b/;
export const monthRegex = /^(?:0?[1-9]|1[012])$/;

export const isOver18 = (year: string, month: string, day: string) => {
  const date18YearsAgo = sub(new Date(), { years: 18 });

  return isBefore(
    new Date(parseInt(year), parseInt(month), parseInt(day)),
    date18YearsAgo,
  );
};
